import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'width', 'wordBreak'];
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};
export var getSizingData = function getSizingData(node) {
  var _window$getComputedSt, _window;
  if (!node) {
    return null;
  }
  var style = (_window$getComputedSt = (_window = window) === null || _window === void 0 ? void 0 : _window.getComputedStyle(node)) !== null && _window$getComputedSt !== void 0 ? _window$getComputedSt : {};
  var sizingStyle = pick(SIZING_STYLE, style);
  if (sizingStyle.boxSizing === '') {
    return null;
  }
  var paddingSize = {
    vertical: parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop),
    horizontal: parseFloat(sizingStyle.paddingLeft) + parseFloat(sizingStyle.paddingRight)
  };
  var borderSize = {
    vertical: parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth),
    horizontal: parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.borderRightWidth)
  };
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};
export var createHiddenNode = function createHiddenNode(ref) {
  var _node$parentNode;
  var node = ref.current;
  var hiddenTextarea = document.createElement('textarea');
  hiddenTextarea.setAttribute('tabindex', '-1');
  hiddenTextarea.setAttribute('aria-hidden', 'true');
  node === null || node === void 0 ? void 0 : (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.appendChild(hiddenTextarea);
  // Используем для калькуляции размеров отображаемого поля
  forceHiddenStyles(hiddenTextarea);
  return hiddenTextarea;
};
export var calculateNodeHeight = function calculateNodeHeight(hiddenTextarea, sizingData, value) {
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
  var paddingSize = sizingData.paddingSize,
    sizingStyle = sizingData.sizingStyle;
  var calculate = function calculate(element, style) {
    forceHiddenStyles(element);
    element.value = value;
    var hiddenAreaHeight = element.scrollHeight;
    element.value = 'x';
    var offset = style.boxSizing === 'border-box' ? paddingSize.vertical : 0;
    var rowHeight = style.lineHeight ? parseFloat(style.lineHeight) : element.scrollHeight - paddingSize.vertical;
    var minHeight = rowHeight + offset;
    var maxHeight = rowHeight * maxRows + offset;
    return {
      height: Math.min(maxHeight, Math.max(minHeight, hiddenAreaHeight)),
      isOverflow: hiddenAreaHeight > maxHeight,
      rows: (hiddenAreaHeight - offset) / rowHeight
    };
  };
  var previousStyle = Object.keys(hiddenTextarea.style).reduce(function (acc, key) {
    if (key in sizingStyle) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, hiddenTextarea.style[key]));
    }
    return acc;
  }, {});

  // Используем сравнение предыдущих и следующих стилей для того чтобы в случае изменения стилей шрифта (body-large и body-medium) у нас не цикличный скачок.
  // Скачок который образовывался из-за того что при количестве строк > 3 у нас уменьшался шрифт, и этот шрифт уже мог помещаться в 3 строки.
  var previousValue = calculate(hiddenTextarea, previousStyle);

  // Задаем те же стили что и оригинальному полю
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  var nextValue = calculate(hiddenTextarea, sizingStyle);
  Object.keys(previousStyle).forEach(function (_key) {
    var key = _key;
    if (previousStyle[key]) {
      hiddenTextarea.style[key] = previousStyle[key];
    }
  });
  return {
    height: nextValue.height,
    // Эта проверка как раз позволяет избежать скачков в размерах описанных выше
    rows: previousValue.rows > nextValue.rows ? previousValue.rows : nextValue.rows,
    isOverflow: nextValue.isOverflow
  };
};